(ns frontend.view.reports.custom.alj-2.completed-deals-charts
  (:require
   [common.util :as cu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn completed-oppos
  []
  (->> (alj/all-deals)
       (filter (fn [oppo]
                 (= (:oppo/status oppo) :oppo.status/portfolio)))))

(defn completed-deals-bu-and-value
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/portfolio)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))]
        [alj-components/deals-by-business-unit
         {:deals           deals
          :view-name       "Completed Deals by SBU - value $M"
          :x-axis-type     :ticket-size-sum
          :date-state-atom date-state-atom}]))))

(defn completed-deals-bu-and-number-of-deals
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/portfolio)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))]
        [alj-components/deals-by-business-unit
         {:deals           deals
          :view-name       "Completed Deals by SBU - Count of Deals"
          :x-axis-type     :number-of-deals
          :date-state-atom date-state-atom}]))))

(defn completed-deals-deal-type-and-value
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/portfolio)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))]
        [alj-components/deals-by-deal-type
         {:deals           deals
          :view-name       "Completed Deals by Deal type - value $M"
          :x-axis-type     :ticket-size-sum
          :date-state-atom date-state-atom
          :descending-by-y? true}]))))

(defn completed-deals-deal-type-and-number-of-deals
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/portfolio)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))]
        [alj-components/deals-by-deal-type
         {:deals           deals
          :view-name       "Completed Deals by Deal type - Count of Deals"
          :x-axis-type     :number-of-deals
          :date-state-atom date-state-atom}]))))
